import key from "./keymaster";

export default window.key = key;
